import { styled, lighten } from "@mui/material/styles";
import { Grid, Button } from "@mui/material";

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  height: "100%",
  justifyContent: "space-around",
  position: "relative",
});
export const CalendarLikeContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: "12px",
  boxShadow: theme.shadows[3],
}));

export const CalendarLikeHeader = styled(Grid)(({ theme }) => ({
  padding: "5px 10px",
  display: "flex",
  backgroundColor: theme.palette.primary.light,
  borderRadius: "12px 12px 0px 0px",
  color: theme.palette.primary.contrastText,
  justifyContent: "space-between",
  alignItems: "center",
  gap: "10px",
  position: "relative",
}));

export const CalendarLikeBody = styled(Grid)(({ theme }) => ({
  display: "flex",
  padding: "5px 10px",
  gap: "10px",
  alignItems: "center",
}));

export const LiveClockContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  width: "112px",
}));

export const CalendarLikeAction = styled(Grid)(({ theme }) => ({
  textTransform: "none",
  display: "flex",
}));

export const ClockInOutContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  backgroundColor: theme.palette.background.paper,
  borderRadius: "8px",
  padding: "15px 10px",
}));

export const ClockInOutButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "clockin",
})<{ clockin: boolean }>(
  {
    width: "75px",
    padding: "5px",
    borderRadius: "8px",
    textTransform: "none",
  },
  ({ clockin, theme }) => ({
    ...(clockin
      ? {
          backgroundColor: lighten(theme.palette.primary.light, 0.4),
          "&:hover": {
            backgroundColor: theme.palette.primary.light,
          },
        }
      : {
          backgroundColor: lighten(theme.palette.warning.main, 0.4),
          "&:hover": {
            backgroundColor: theme.palette.warning.main,
          },
        }),
  })
);
